/**
 * /dashboard/performance/cycles — HR-admin cycle administration.
 *
 * Reuses the ReviewsTab body — it shows the review cycles list + the
 * "New cycle" CTA (gated on isPerfAdmin client-side; the backend
 * RBAC-enforces the mutation too).
 *
 * Migration note: port of
 * frontend/src/app/(dashboard)/dashboard/performance/cycles/page.tsx.
 */

import { createFileRoute } from "@tanstack/react-router";
import { PerformanceModuleShell } from "@/components/shared/performance-module-shell";
import { PerformanceFeatureGate } from "@/components/performance/performance-feature-gate";
import { ReviewsTab } from "@/components/performance/reviews-tab";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/performance/cycles",
)({
  component: PerformanceCyclesRoute,
});

function PerformanceCyclesRoute() {
  return (
    <PerformanceModuleShell
      title="Cycle administration"
      description="HR runs review cycles from here. Create, transition and close."
    >
      <PerformanceFeatureGate>
        <ReviewsTab />
      </PerformanceFeatureGate>
    </PerformanceModuleShell>
  );
}
